'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'car';
var width = 512;
var height = 512;
var aliases = [128664,"automobile"];
var unicode = 'f1b9';
var svgPathData = 'M118.4 112.8L92 192 420 192 393.6 112.8C387.1 93.2 368.8 80 348.1 80L163.9 80c-20.7 0-39 13.2-45.5 32.8zM39.8 196.7l33-99.1C85.9 58.4 122.6 32 163.9 32l184.2 0c41.3 0 78 26.4 91.1 65.6l33 99.1c23.3 9.5 39.8 32.5 39.8 59.3l0 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-416 0 0 40c0 13.3-10.7 24-24 24S0 469.3 0 456L0 256c0-26.8 16.4-49.7 39.8-59.3zM64 240c-8.8 0-16 7.2-16 16l0 112 416 0 0-112c0-8.8-7.2-16-16-16L64 240zm48 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;